
import React from 'react';

export const BackgroundEffects = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none -z-10">
    {/* Animated grid background */}
    <div className="absolute inset-0 dark-grid"></div>
    
    {/* Circuit patterns */}
    <div className="absolute inset-0 circuit-pattern"></div>
    
    {/* Glowing orbs */}
    <div className="dark-orbs -z-10">
      {[...Array(5)].map((_, i) => (
        <div
          key={i}
          className="dark-orb"
          style={{
            left: `${20 + i * 15}%`,
            top: `${30 + (i % 3) * 20}%`,
            animationDelay: `${i * 0.5}s`,
            zIndex: '-1'
          }}
        ></div>
      ))}
    </div>

    {/* Energy lines */}
    <div className="dark-energy-lines -z-10">
      {[...Array(8)].map((_, i) => (
        <div
          key={i}
          className="dark-energy-line"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${i * 0.3}s`,
            zIndex: '-1'
          }}
        ></div>
      ))}
    </div>

    {/* Data streams */}
    <div className="dark-data-streams -z-10">
      {[...Array(15)].map((_, i) => (
        <div
          key={i}
          className="dark-data-stream"
          style={{
            left: `${Math.random() * 100}%`,
            animationDuration: `${3 + Math.random() * 4}s`,
            animationDelay: `${Math.random() * 2}s`,
            zIndex: '-1'
          }}
        >
          {[...Array(10)].map((_, j) => (
            <span
              key={j}
              style={{
                animationDelay: `${j * 0.1}s`
              }}
            >
              {String.fromCharCode(33 + Math.floor(Math.random() * 94))}
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const TypingIndicator = () => (
  <div className="flex items-center space-x-2 p-4">
    <div className="flex space-x-1">
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className="dark-typing-dot"
          style={{ animationDelay: `${i * 0.15}s` }}
        ></div>
      ))}
    </div>
  </div>
); 